import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)         return savedPosition
        if (to.hash)               return { el: to.hash }
        if (from.path === to.path) return {}
        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path: '/',
            redirect: '/dashboard',
        },
        {
            path:      '/login',
            name:      'login',
            component: () => import('@/views/Login.vue'),
            meta:      { layout: 'Blank', requiresAuth: false },
        },
        {
            path:      '/dashboard',
            name:      'dashboard',
            component: () => import('@/views/Dashboard.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/shifts',
            name:      'shifts',
            component: () => import('@/views/shift/Shifts.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/tickets',
            name:      'tickets',
            component: () => import('@/views/ticket/MaintenanceTickets.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/shifts/new',
            name:      'shift-new',
            component: () => import('@/views/shift/ShiftForm.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/shifts/:id',
            name:      'shift-detail',
            component: () => import('@/views/shift/ShiftDetail.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/faults',
            name:      'faults',
            component: () => import('@/views/fault/Faults.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/reports',
            name:      'reports',
            component: () => import('@/views/report/Reports.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/electricity',
            name:      'electricity',
            component: () => import('@/views/electricity/Electricity.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/incidents',
            name:      'incidents',
            component: () => import('@/views/incident/Incidents.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/incidents/new',
            name:      'incident-new',
            component: () => import('@/views/incident/IncidentForm.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/incidents/:id',
            name:      'incident-detail',
            component: () => import('@/views/incident/IncidentDetail.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/personnel',
            name:      'personnel',
            component: () => import('@/views/personnel/Personnel.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/reference',
            name:      'reference',
            component: () => import('@/views/reference/Reference.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/schedule',
            name:      'schedule',
            component: () => import('@/views/schedule/Schedule.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/field-bounds',
            name:      'field-bounds',
            component: () => import('@/views/fieldbounds/FieldBounds.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/users',
            name:      'users',
            component: () => import('@/views/user/Users.vue'),
            meta:      { requiresAuth: true },
        },
    ],
})

router.beforeEach((to, _from, next) => {
    const appStore = useAppStore()
    const loggedIn = isAuthenticated()

    if (loggedIn && to.name === 'login') return next({ name: 'dashboard' })
    if (to.meta.requiresAuth && !loggedIn) {
        appStore.setLogout()
        return next({ name: 'login' })
    }
    next()
})

export default router
